import { type Variants, useReducedMotionConfig } from "framer-motion";

export const staggerContainer: Variants = {
  hidden: {},
  show: { transition: { staggerChildren: 0.04 } },
};

export const fadeSlideUp: Variants = {
  hidden: { opacity: 0, y: 8 },
  show: { opacity: 1, y: 0, transition: { duration: 0.2 } },
};

export const countUpTransition = { duration: 0.6, ease: [0.16, 1, 0.3, 1] };

export const pulseKeyframes = {
  boxShadow: [
    "0 0 0 0 rgba(224,164,88,0.55)",
    "0 0 0 7px rgba(224,164,88,0)",
    "0 0 0 0 rgba(224,164,88,0)",
  ],
};

export function useMotionVariants() {
  const reduced = useReducedMotionConfig() ?? false;

  const fadeSlideUp: Variants = reduced
    ? {
        hidden: { opacity: 1, y: 0 },
        show: { opacity: 1, y: 0, transition: { duration: 0 } },
      }
    : {
        hidden: { opacity: 0, y: 8 },
        show: { opacity: 1, y: 0, transition: { duration: 0.2 } },
      };

  const staggerContainer: Variants = reduced
    ? { hidden: {}, show: { transition: { staggerChildren: 0 } } }
    : { hidden: {}, show: { transition: { staggerChildren: 0.04 } } };

  return { fadeSlideUp, staggerContainer, reduced };
}
